import { coerceFilterValues } from '#/modules/commonComponents/table/columnFilterUtils';

function readFieldValue(row, fieldPath) {
  if (!fieldPath || row == null) {
    return undefined;
  }

  const parts = String(fieldPath).split('.');
  let value = row;
  for (const part of parts) {
    if (value == null) {
      return undefined;
    }
    value = value[part];
  }

  return value;
}

function normalizeText(value) {
  if (value == null || value === '') {
    return '';
  }
  return String(value).trim().toLowerCase();
}

/**
 * 文字 filter（支援 dot path；`fieldPath` 可為字串陣列以 OR 比對多欄）。
 */
export function matchesTextFilter(row, fieldPath, value) {
  const query = normalizeText(value);
  if (!query) {
    return true;
  }

  const paths = Array.isArray(fieldPath) ? fieldPath : [fieldPath];
  const haystack = paths
    .map((path) => normalizeText(readFieldValue(row, path)))
    .filter(Boolean)
    .join(' ');

  return haystack.includes(query);
}

/**
 * fixed／async multi filter（row 欄位值須在選取值內）。
 */
export function matchesMultiFilter(row, field, values) {
  const selected = coerceFilterValues(values);
  if (selected.length === 0) {
    return true;
  }

  const fieldValue = readFieldValue(row, field);
  if (fieldValue == null || fieldValue === '') {
    return false;
  }

  return selected.includes(String(fieldValue));
}

/**
 * 日期 range filter（`dateField` 值取前 10 字元 YYYY-MM-DD 比對）。
 */
export function matchesDateRangeFilter(row, dateField, from, to) {
  if (!from && !to) {
    return true;
  }

  const raw = readFieldValue(row, dateField);
  if (!raw) {
    return false;
  }

  const date = String(raw).slice(0, 10);
  if (from && date < from) {
    return false;
  }
  if (to && date > to) {
    return false;
  }

  return true;
}
